export const rugCardsSegment = {
  padding: 30,
}
